import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { ReactComponent as ExternalLink } from '../../assets/icons/external_link.svg';
import { tag } from '../../services/ATInternetService';
import SecondaryButton from '../buttons/secondarybutton/SecondaryButton';
import './FeedbackButton.sass';


const NEXT_MESSAGE_TIME = 10 * 1000;

const messages = [
	'Wil je ons helpen?',
	'Geef jouw mening!',
	'Geef dit een cijfer!'
]

const FeedbackButton = ({ className }) => {

	const [messageText, setMessageText] = useState(messages[Math.floor(Math.random() * messages.length)]);

	useEffect(() => {
		const interval = setInterval(() => {
			setMessageText(messages[Math.floor(Math.random() * messages.length)]);
		}, NEXT_MESSAGE_TIME);
		return () => clearInterval(interval);
	}, [messageText]);

	return <SecondaryButton
		className={`feedbackbutton flex flex-row justify-center ${className}`}
		onClick={() => {
			window.open('https://forms.office.com/r/v50dtLQzf5', '_blank').focus();
			tag.sendClick('feedback', {
				name: 'feedback-button-pressed',
			});
		}}>

		<span>{messageText}</span><ExternalLink className="ml-4 h-8 w-8 transform -translate-y-1" />
	</SecondaryButton>;
};

FeedbackButton.propTypes = {
	className: PropTypes.string,
}

FeedbackButton.defaultProps = {
	className: undefined,
}

export default FeedbackButton;
